
import axios, { type AxiosInstance } from "axios"
import { getExhibitionHeader } from "../utils/exhibitionContext";
import {
  BadgeReportData,
  ReportQueryParams,
  PaginatedReportResponse,
} from "../Component/Application/badgeReporting/types"


const api: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://127.0.0.1:8000",
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000,
})

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken")
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`
    Object.assign(config.headers, getExhibitionHeader());
    }
    return config
  },
  (error) => Promise.reject(error),
)

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("accessToken")
      window.location.href = "/auth/login/"
    }
    return Promise.reject(error)
  },
)

const BadgeReportingService = {
  async getBadgeReport(
    params: ReportQueryParams & { page?: number; pageSize?: number },
  ): Promise<PaginatedReportResponse<BadgeReportData>> {
    try {
      const response = await api.get("/api/badges/reports/", { params })
      return response.data
    } catch (error) {
      console.error("Error fetching badge report:", error)
      throw new Error("Failed to fetch badge report data.")
    }
  },

  async exportBadgeReport(params: ReportQueryParams): Promise<Blob> {
    try {
      const response = await api.get("/api/badges/reports/export/", { params, responseType: "blob" })
      return response.data
    } catch (error) {
      console.error("Error exporting badge report:", error)
      throw new Error("Failed to export badge report.")
    }
  },
}

export default BadgeReportingService
